module.exports = __webpack_public_path__ + "static/media/TrierweilerCreates-white.4b6ee793.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/TrierweilerCreates-white.png
// module id = 52
// module chunks = 0